export default {"src":"/_next/static/media/tennis.c9b39bde.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};